import styled from 'styled-components'

import { FONT_SIZE, COLOR, NATIVE_BASE_COLORS} from '../../../../../themes'

const Style = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px 20px 24px;

  .issue-footer-message-layout {
    display: flex;
    flex-direction: column;
  }

  .issue-footer-title {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${COLOR.BLACK};
    white-space: nowrap;
  }

  .issue-footer-sub-title {
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.TN};
    color: ${NATIVE_BASE_COLORS.TEXT[500]};
    white-space: nowrap;
  }

  .report-button {
    width: 140px;
    height: 44px;
    border-radius: 4px;
    border: 0px;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${COLOR.BLACK};
    background-color: ${({ colorTheme }) => colorTheme || NATIVE_BASE_COLORS.PRIMARY[200]};
  }
`

export default Style
